<template>
    <div>
        <vuestic-modal
            :show.sync="modalInfo.show"
            v-bind:force="true"
            ref="modalInfo"
            :cancelText="$t('modal.cancel')"
            :okText="$t('firewall.remove')"
            @ok="deleteRule(modalInfo.rule)"
        >
            <div slot="title">{{ modalInfo.title }}</div>
            <div>{{ modalInfo.body }}</div>
        </vuestic-modal>
        <table class="table table-striped first-td-padding">
            <thead>
                <tr>
                    <td>{{$t('firewall.type')}}</td>
                    <td>{{$t('firewall.protocol')}}</td>
                    <td>{{$t('firewall.portRange')}}</td>

                    <td v-if="sources == 'in'">{{$t('firewall.sources')}}</td>
                    <td v-if="sources == 'out'">{{$t('firewall.sourcesout')}}</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(rule, key) in rules" :id="key" :key="key">
                    <td>
                        <select v-if="isEditing(rule)" v-model="rule.macro" @change="changedRuleTo(rule)">
                            <option v-for="(ruleMacro, index) in rulesMacros" :key="index" :value="ruleMacro.macro">{{ruleMacro.macro}}</option>
                        </select>
                        <template v-else>
                            {{ rule.macro || '-' }}
                        </template>
                    </td>
                    <td>
                        <select v-model="rule.proto" v-if="isEditing(rule) && !isLocked(rule)">
                            <option v-for="(protocol, index) in ruleProtocols" :key="index" :value="protocol">{{protocol}}</option>
                        </select>
                        <span v-else>
                            {{rule.proto.toUpperCase() || '-'}}
                        </span>
                    </td>
                    <td>
                        <input v-if="isEditing(rule) && !isLocked(rule)" type="text" v-model="rule.dport" />
                        <template v-else>
                            {{ rule.dport || '-'}}
                        </template>
                    </td>
                    <td>
                        <div v-if="!isEditing(rule)">
                            <span class="bg-pale px-1 mr-1">
                                {{ rule.source || $t('firewall.any') }}
                            </span>
                        </div>
                        <input type="text" v-else v-model="rule.source" :disabled="false" />
                    </td>
                    <td class="text-right" v-if="!rule.in_progress">
                        <span v-if="isCreating">
                            <button class="btn btn-sm btn-warning" @click="$emit('cancel', rule)" >
                                {{$t('firewall.delete')}}
                            </button>
                        </span>
                        <span v-else-if="isEditing(rule)">

                            <button class="btn btn-sm btn-primary" @click="emitSave(rule)" >
                                {{$t('firewall.ruleSave')}}
                            </button>
                            <button class="btn btn-sm btn-warning" @click="$emit('cancel', rule)" >
                                {{$t('firewall.ruleCancel')}}
                            </button>
                        </span>
                        <div class="text-right" v-else>
                            <div class="form-group dropdown m-0 d-block" v-dropdown.closeOnMenuClick>
                                <button class="btn btn-primary btn-sm dropdown-toggle" type="button"
                                        data-toggle="dropdown" >
                                    {{$t('firewall.options')}}
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <div class="dropdown-menu-content">
                                        <a class="dropdown-item" @click="setEditing(rule)">{{$t('firewall.edit')}}</a>
                                        <a class="dropdown-item" @click="remove(rule)">{{$t('firewall.remove')}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="text-center" v-else>
                        <div class="spinner spinner-md"></div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import SourceTags from './SourceTags'
export default {
    props: {
        rules: {
            required: true
        },
        rulesMacros: {
            required: true
        },
        ruleProtocols: {
            required: true
        },
        isCreating: {

        },
        sources: {

        }
    },
    components: {
        SourceTags
    },

    data () {
        return {
            modalInfo: {
                show: true,
                rule: null,
                title: this.$t('firewall.delete_rule'),
                body: this.$t('firewall.delete_rule_confirm'),
            }
        }
    },

    methods: {
        isEditing (rule) {
            return rule.is_editing === true || !rule.id
        },
        isLocked (rule) {
            return rule.macro !== 'Custom'
        },
        setEditing (rule) {
            rule.original = JSON.parse(JSON.stringify(rule))
            if(rule.macro === '') {
                rule.macro = 'Custom'
            }
            rule.proto = rule.proto.toUpperCase()
            this.$set(rule, 'is_editing', true)
        },
        remove (rule) {
            this.modalInfo.rule = rule
            this.$refs.modalInfo.open()
        },
        changedRuleTo (rule, type) {
            let ruleMacro = this.rulesMacros.find(r => r.macro === rule.macro)
            if (ruleMacro) {
                rule.proto = ruleMacro.proto
                rule.dport = ruleMacro.dport
            }
        },
        emitSave (rule) {
            // Regex to match valid IPv6 addresses
            const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}:)|(([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4})|(([0-9a-fA-F]{1,4}:){1,5}(?::[0-9a-fA-F]{1,4}){1,2})|(([0-9a-fA-F]{1,4}:){1,4}(?::[0-9a-fA-F]{1,4}){1,3})|(([0-9a-fA-F]{1,4}:){1,3}(?::[0-9a-fA-F]{1,4}){1,4})|(([0-9a-fA-F]{1,4}:){1,2}(?::[0-9a-fA-F]{1,4}){1,5})|([0-9a-fA-F]{1,4}:)((?::[0-9a-fA-F]{1,4}){1,6})|:((?::[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(?::[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(?:ffff(?::0{1,4})?:){0,1}((25[0-5]|(2[0-4]|1?[0-9])?[0-9])\.){3}(25[0-5]|(2[0-4]|1?[0-9])?[0-9])|(?:[0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1?[0-9])?[0-9])\.){3}(25[0-5]|(2[0-4]|1?[0-9])?[0-9]))$/;
            
            // Regex to match valid IPv4 addresses (no netmask)
            const ipv4Regex = /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/;

            // Regex to match valid IPv4 ranges separated by hyphens
            const ipv4RangeRegex = /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)-((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/;

            // Regex to match valid port or port ranges (e.g., 80 or 80:85)
            const portRegex = /^([1-9]\d{0,4}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])(?:\:([1-9]\d{0,4}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5]))?$/;

            // Trim whitespace and remove trailing commas or invalid characters
            rule.dport = rule.dport.trim().replace(/,+$/, '');
            rule.source = rule.source.trim().replace(/,+$/, '');

            // Split the source by commas, trim each entry, and filter out empty strings
            const sources = rule.source.split(',').map(s => s.trim()).filter(s => s !== '');

            // Check if there's more than one source
            if (sources.length > 1) {
                // Iterate through sources to ensure none are ranges
                for (let source of sources) {
                source = source.trim();
                if (ipv4RangeRegex.test(source)) {
                    this.showToast(this.$t('firewall.toast_no_range_in_list'), {
                    icon: "fa-remove",
                    position: "top-center",
                    duration: 3000,
                    fullWidth: false,
                    });
                    return false;
                }
                }
            }

            // Validate each source
            for (let source of sources) {
                source = source.trim();
                if (
                source !== '' &&
                !ipv4Regex.test(source) &&
                !ipv6Regex.test(source) &&
                !ipv4RangeRegex.test(source)
                ) {
                this.showToast(this.$t('firewall.toast_invalid_ip', {ip: source}), {
                    icon: "fa-remove",
                    position: "top-center",
                    duration: 3000,
                    fullWidth: false,
                });
                return false;
                }
            }

           // Validate dport to allow single ports or port ranges (e.g., 80 or 80:85)
            if (rule.dport.length) {
                const portMatch = rule.dport.match(portRegex);
                if (!portMatch) {
                    this.showToast(this.$t('firewall.toast_invalid_port_format'), {
                        icon: "fa-remove",
                        position: "top-center",
                        duration: 3000,
                        fullWidth: false,
                    });
                    return false;
                }

                if (portMatch[2]) { // If it's a port range
                    const startPort = parseInt(portMatch[1], 10);
                    const endPort = parseInt(portMatch[2], 10);
                    if (startPort >= endPort) {
                        this.showToast(this.$t('firewall.toast_invalid_port_range'), {
                        icon: "fa-remove",
                        position: "top-center",
                        duration: 3000,
                        fullWidth: false,
                        });
                        return false;
                    }
                }
            }

            this.$emit('save', rule)
            this.$set(rule, 'is_editing', false)
        },
        deleteRule (rule) {
            this.$emit('removeRule', rule)
        }
    }
}
</script>
   <style>
.spinner {
    height:40px;
    width:40px;
    margin:0 auto;
    position:relative;
    -webkit-animation: rotation .6s infinite linear;
    -moz-animation: rotation .6s infinite linear;
    -o-animation: rotation .6s infinite linear;
    animation: rotation .6s infinite linear;
    border:6px solid rgba(0,174,239,.15);
    border-radius:100%;
}

.spinner:before {
    content:"";
    display:block;
    position:absolute;
    left:-6px;
    top:-6px;
    height:100%;
    width:100%;
    border-top:6px solid rgba(0,174,239,.8);
    border-left:6px solid transparent;
    border-bottom:6px solid transparent;
    border-right:6px solid transparent;
    border-radius:100%;
}

@-webkit-keyframes rotation {
from {-webkit-transform: rotate(0deg);}
to {-webkit-transform: rotate(359deg);}
}
@-moz-keyframes rotation {
from {-moz-transform: rotate(0deg);}
to {-moz-transform: rotate(359deg);}
}
@-o-keyframes rotation {
from {-o-transform: rotate(0deg);}
to {-o-transform: rotate(359deg);}
}
@keyframes rotation {
from {transform: rotate(0deg);}
to {transform: rotate(359deg);}
}
a:not([href]):not([tabindex]) {
  color: #000 !important;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/firewalls/FirewallRulesTable.vue